<template>
  <div class="data-grid">
    <div class="d-flex align-items-center align-items-sm-start">
      <atom-custom-avatar avatar-icon="UserIcon"></atom-custom-avatar>
      <span class="text-medium-black pl-1 d-flex d-sm-none">{{ name }}</span>
    </div>
    <div class="contact-detail d-flex flex-column">
      <span class="text-medium-black d-none d-sm-block">{{ name }}</span>
      <span class="font-size-12 custom-line-height pl-4 pl-sm-0">
        {{ role }}
      </span>
      <div class="contact-phone d-flex align-items-center pl-4 pl-sm-0">
        <feather-icon
          icon="PhoneIcon"
          size="12"
          class="icon__size"
        ></feather-icon>
        <span class="font-size-12 pl-1 custom-line-height">
          {{ phoneFormatter(contactPhone) }}
        </span>
      </div>
      <div class="contact-phone d-flex align-items-center pl-4 pl-sm-0">
        <feather-icon
          icon="MailIcon"
          size="12"
          class="icon__size"
        ></feather-icon>
        <span class="font-size-12 pl-1 custom-line-height">
          {{ contactEmail }}
        </span>
      </div>
    </div>
    <div class="notification-detail">
      <span
        class="text-uppercase font-size-12 mt-1 text-color-grey d-block d-sm-none"
      >
        Notification
      </span>
      <div
        class="notification-system d-flex align-items-center pl-4 pl-sm-0"
        :class="[
          systemNotification.isEnable
            ? 'text-color-primary'
            : 'text-color-grey',
        ]"
      >
        <feather-icon
          icon="BellIcon"
          size="12"
          class="icon__size"
        ></feather-icon>
        <span class="font-size-12 pl-1 custom-line-height"
          >System Notification</span
        >
      </div>
      <div
        class="notification-email d-flex align-items-center pl-4 pl-sm-0"
        :class="[
          emailNotification.isEnable ? 'text-color-primary' : 'text-color-grey',
        ]"
      >
        <feather-icon
          icon="MailIcon"
          size="12"
          class="icon__size"
        ></feather-icon>
        <span class="font-size-12 pl-1 custom-line-height">
          {{ emailNotification.email }}
        </span>
      </div>
      <div
        class="notification-line d-flex align-items-center pl-4 pl-sm-0"
        :class="[
          lineNotification.isEnable ? 'text-color-primary' : 'text-color-grey',
        ]"
      >
        <feather-icon
          icon="MessageCircleIcon"
          size="12"
          class="icon__size"
        ></feather-icon>
        <span class="font-size-12 pl-1 custom-line-height">
          {{ lineNotification.lineTokenAlias }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AtomCustomAvatar from "./AtomCustomAvatar.vue"
export default {
  name: "AtomEscalationAvatar",
  components: {
    AtomCustomAvatar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      required: false,
      default: "-",
    },
    contactPhone: {
      type: String,
      required: false,
      default: "-",
    },
    contactEmail: {
      type: String,
      required: false,
      default: "-",
    },
    systemNotification: {
      type: Object,
      required: true,
    },
    emailNotification: {
      type: Object,
      required: true,
    },
    lineNotification: {
      type: Object,
      required: true,
    },
  },
  methods: {
    phoneFormatter(phone) {
      if (phone[1] === "6" || phone[1] === "8" || phone[1] === "9") {
        let splitPhone = phone
          .replace(/\D/g, "")
          .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
        return `${splitPhone[1]} ${splitPhone[2]} ${splitPhone[3]}`
      } else if (phone[1] === "2") {
        let splitPhone = phone
          .replace(/\D/g, "")
          .match(/(\d{0,2})(\d{0,3})(\d{0,4})/)
        return `${splitPhone[1]} ${splitPhone[2]} ${splitPhone[3]}`
      } else {
        return phone
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.data-grid {
  display: grid;
  grid-template-columns: 1fr;
}

.custom-line-height {
  line-height: 24px;
}

.icon__size {
  min-width: 12px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .data-grid {
    display: grid;
    grid-template-columns: 1fr 4fr 3.5fr;
  }

  .custom-line-height {
    line-height: 20px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
